/** Influx aggregateWindow の空窓など、(0,0) かつ時刻が無効な行を除外するための判定 */
export function isPlaceholderGeometrics(e) {
    const badTime = typeof e.time !== 'number' || !Number.isFinite(e.time) || e.time <= 0;
    const lat = e.latitude;
    const lng = e.longitude;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return true;
    }
    return lat === 0 && lng === 0 && badTime;
}
